import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import PublicModalView from "../../components/PublicModalView";
import ReadIcon from "../../assets/read-icon.png";
const BASE_URL = process.env.REACT_APP_BASE_URL || "https://api.axionnest.com";

export default function RightColumn() {
    const [activeTab, setActiveTab] = useState("post");
    const [roleType, setRoleType] = useState("Job Offer");
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [modalType, setModalType] = useState(null);
    const [activePost, setActivePost] = useState(null);
    const token = localStorage.getItem("access_token");
    const navigate = useNavigate();
    const [expanded, setExpanded] = useState(false);
    const [postForm, setPostForm] = useState({
        title: "",
        content: "",
    });

    const [jobForm, setJobForm] = useState({
        job_title: "",
        company_name: "",
        location: "",
        experience_level: "",
        compensation: "",
        contact_email: "",
        description: "",
    });
  

    useEffect(() => {
        fetchPosts();
    }, []);

    async function fetchPosts() {
        try {
            setLoading(true);
            const res = await fetch(`${BASE_URL}/user/posts/`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                    "x-api-key": process.env.REACT_APP_X_API_KEY
                },
            });
            const data = await res.json();
            // console.log("The posts data are:",data.results)
            setPosts(data.results || data || []);
        } catch (err) {
            console.error("Error fetching posts:", err);
            toast.error("Failed to load posts");
        } finally {
            setLoading(false);
        }
    }

    async function handlePostSubmit() {
        if (!postForm.title || !postForm.content) {
            toast.warn("Please enter title and content");
            return;
        }
        try {
            setLoading(true);
            const res = await fetch(`${BASE_URL}/user/posts/`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                    "x-api-key": process.env.REACT_APP_X_API_KEY
                },
                body: JSON.stringify({
                    title: postForm.title,
                    content: `<p>${postForm.content}</p>`,
                    post_type: "normal",
                }),
            });

            if (res.ok) {
                toast.success("Post created successfully!");
                setPostForm({ title: "", content: "" });
                fetchPosts();
            } else {
                const errData = await res.json();
                console.error("Failed to post:", errData);
                toast.error(errData?.message || "Error creating post");
            }
        } catch (err) {
            console.error(err);
            toast.error("Something went wrong while creating the post");
        } finally {
            setLoading(false);
        }
    }

    async function handleJobSubmit() {
        if (!jobForm.job_title || !jobForm.company_name) {
            toast.warn("Please fill all required fields");
            return;
        }

        try {
            setLoading(true);
            const res = await fetch(`${BASE_URL}/user/posts/`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                    "x-api-key": process.env.REACT_APP_X_API_KEY
                },
                body: JSON.stringify({
                    post_type: "job",
                    title: jobForm.job_title,
                    content: jobForm.description,
                    job_title: jobForm.job_title,
                    company_name: jobForm.company_name,
                    location: jobForm.location,
                    experience_level: jobForm.experience_level || "mid",
                    salary_min: jobForm.salary_min || "0",
                    salary_max: jobForm.salary_max || "0",
                    currency: jobForm.currency || "USD",
                    job_type: jobForm.job_type || "full_time",
                    skills_required: jobForm.skills_required,
                    qualifications: jobForm.qualifications,
                    application_email: jobForm.contact_email,
                    application_url: jobForm.application_url || "",
                }),
            });

            if (res.ok) {
                toast.success("Job post created successfully!");
                setJobForm({
                    job_title: "",
                    company_name: "",
                    location: "",
                    experience_level: "",
                    compensation: "",
                    contact_email: "",
                    description: "",
                    job_type: "",
                    salary_min: "",
                    salary_max: "",
                    currency: "",
                    skills_required: "",
                    qualifications: "",
                    application_url: "",
                });
                fetchPosts();
            } else {
                const errData = await res.json();
                console.error("Failed to create job:", errData);
                toast.error(errData?.message || "Error creating job post");
            }
        } catch (err) {
            console.error(err);
            toast.error("Something went wrong while creating job post");
        } finally {
            setLoading(false);
        }
    }

    const handleTabSwitch = (tab) => setActiveTab(tab);
    const handleRoleChange = (e) => setRoleType(e.target.value);

    return (
<>
  <aside className=" flex flex-col gap-4 flex-1 w-full">

  <section className="
    w-full
    rounded-2xl border border-gray-200
    bg-white
    p-6
    shadow-sm
    transition-all duration-200
    hover:shadow-md
    hover:border-gray-300
  ">
    {/* Header */}
    {/* Header with icon and lightweight bg */}
<div className="flex items-center gap-3 p-4 bg-[#e8f0f7] rounded-xl mb-6">
  <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center flex-shrink-0">
    <svg
      className="w-5 h-5 text-[#0f6abf]"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
      />
    </svg>
  </div>
  <div className="flex-1 min-w-0">
  <div className="flex items-center gap-2 flex-wrap">
    <div className="text-sm font-semibold text-gray-900 break-words">
      Post to Network
    </div>
    <div className="text-xs text-gray-500 break-words">
      Academia ↔ Industry
    </div>
  </div>
</div>

</div>

{/* Tabs with icons */}
<div className="flex bg-gray-100 rounded-xl p-1 mb-6">
  {/* Post Tab */}
  <div
    className={`flex-1 flex items-center justify-center gap-2 py-3 px-4 text-sm font-medium cursor-pointer rounded-lg transition-all duration-200 ${
      activeTab === "post"
        ? "bg-white text-[#0f6abf] shadow-sm"
        : "text-gray-500 hover:text-gray-700"
    }`}
    onClick={() => handleTabSwitch("post")}
  >
    
    <span className="truncate">Publication / Update</span>
  </div>

  {/* Job Tab */}
  <div
    className={`flex-1 flex items-center justify-center gap-2 py-3 px-4 text-sm font-medium cursor-pointer rounded-lg transition-all duration-200 ${
      activeTab === "job"
        ? "bg-white text-[#0f6abf] shadow-sm"
        : "text-gray-500 hover:text-gray-700"
    }`}
    onClick={() => handleTabSwitch("job")}
  >
    <span className="truncate">Hiring / Position</span>
  </div>
</div>


    {/* Post Form */}
    {activeTab === "post" && (
      <div className="composer-body flex flex-col gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Title / Subject</label>
          <input
            type="text"
            placeholder="Looking for partner in biomedical imaging project..."
            className="w-full border border-gray-300 rounded-xl p-3 text-sm bg-white text-gray-900 outline-none focus:border-[#0f6abf] focus:ring-1 focus:ring-[#0f6abf]/20 transition-colors"
            value={postForm.title}
            onChange={(e) =>
              setPostForm({ ...postForm, title: e.target.value })
            }
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Content / Message</label>
          <textarea
            placeholder="Scientific note, publication summary, dataset request, etc."
            className="w-full border border-gray-300 rounded-xl p-3 text-sm bg-white text-gray-900 outline-none focus:border-[#0f6abf] focus:ring-1 focus:ring-[#0f6abf]/20 min-h-[100px] resize-y transition-colors"
            value={postForm.content}
            onChange={(e) =>
              setPostForm({ ...postForm, content: e.target.value })
            }
          ></textarea>
        </div>
        
        <button
          className="submit-btn mt-2 py-3 px-4 rounded-xl border-none bg-[#0f6abf] text-white text-sm font-medium cursor-pointer hover:bg-[#0a5ca8] transition-colors disabled:opacity-50"
          onClick={handlePostSubmit}
          disabled={loading}
        >
          {loading ? "Posting..." : "Share with AxionNest"}
        </button>
      </div>
    )}

    {/* Job Form */}
    {activeTab === "job" && (
      <div className="composer-body flex flex-col gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Job Title</label>
          <input
            type="text"
            placeholder="AI Engineer / NLP Researcher"
            className="w-full border border-gray-300 rounded-xl p-3 text-sm bg-white text-gray-900 outline-none focus:border-[#0f6abf] focus:ring-1 focus:ring-[#0f6abf]/20 transition-colors"
            value={jobForm.job_title}
            onChange={(e) =>
              setJobForm({ ...jobForm, job_title: e.target.value })
            }
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Company / Organization</label>
          <input
            type="text"
            placeholder="AxionNest Labs"
            className="w-full border border-gray-300 rounded-xl p-3 text-sm bg-white text-gray-900 outline-none focus:border-[#0f6abf] focus:ring-1 focus:ring-[#0f6abf]/20 transition-colors"
            value={jobForm.company_name}
            onChange={(e) =>
              setJobForm({ ...jobForm, company_name: e.target.value })
            }
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Location</label>
          <input
            type="text"
            placeholder="Remote / Paris / Montreal..."
            className="w-full border border-gray-300 rounded-xl p-3 text-sm bg-white text-gray-900 outline-none focus:border-[#0f6abf] focus:ring-1 focus:ring-[#0f6abf]/20 transition-colors"
            value={jobForm.location}
            onChange={(e) =>
              setJobForm({ ...jobForm, location: e.target.value })
            }
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Experience Level</label>
          <select
            className="w-full border border-gray-300 rounded-xl p-3 text-sm bg-white text-gray-900 outline-none focus:border-[#0f6abf] focus:ring-1 focus:ring-[#0f6abf]/20 transition-colors appearance-none"
            style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%2390A3BF' stroke-width='1.5'/%3E%3C/svg%3E")`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right 12px center'
            }}
            value={jobForm.experience_level}
            onChange={(e) =>
              setJobForm({ ...jobForm, experience_level: e.target.value })
            }
          >
            <option value="">Select Experience Level</option>
            <option value="entry">Entry Level (0-2 years)</option>
            <option value="mid">Mid Level (2-5 years)</option>
            <option value="senior">Senior Level (5-10 years)</option>
            <option value="lead">Lead Level (10+ years)</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Job Type</label>
          <select
            className="w-full border border-gray-300 rounded-xl p-3 text-sm bg-white text-gray-900 outline-none focus:border-[#0f6abf] focus:ring-1 focus:ring-[#0f6abf]/20 transition-colors appearance-none"
            style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%2390A3BF' stroke-width='1.5'/%3E%3C/svg%3E")`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'right 12px center'
            }}
            value={jobForm.job_type || ""}
            onChange={(e) =>
              setJobForm({ ...jobForm, job_type: e.target.value })
            }
          >
            <option value="">Select Job Type</option>
            <option value="full_time">Full Time</option>
            <option value="part_time">Part Time</option>
            <option value="contract">Contract</option>
            <option value="freelance">Freelance</option>
            <option value="internship">Internship</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Salary Range</label>
          <div className="flex gap-3">
            <input
              type="number"
              placeholder="Min (e.g. 10000)"
              className="w-full border border-gray-300 rounded-xl p-3 text-sm bg-white text-gray-900 outline-none focus:border-[#0f6abf] focus:ring-1 focus:ring-[#0f6abf]/20 transition-colors"
              value={jobForm.salary_min || ""}
              onChange={(e) =>
                setJobForm({ ...jobForm, salary_min: e.target.value })
              }
            />
            <input
              type="number"
              placeholder="Max (e.g. 100000)"
              className="w-full border border-gray-300 rounded-xl p-3 text-sm bg-white text-gray-900 outline-none focus:border-[#0f6abf] focus:ring-1 focus:ring-[#0f6abf]/20 transition-colors"
              value={jobForm.salary_max || ""}
              onChange={(e) =>
                setJobForm({ ...jobForm, salary_max: e.target.value })
              }
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Currency</label>
          <input
            type="text"
            placeholder="INR / USD"
            className="w-full border border-gray-300 rounded-xl p-3 text-sm bg-white text-gray-900 outline-none focus:border-[#0f6abf] focus:ring-1 focus:ring-[#0f6abf]/20 transition-colors"
            value={jobForm.currency || ""}
            onChange={(e) =>
              setJobForm({ ...jobForm, currency: e.target.value })
            }
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Skills Required</label>
          <input
            type="text"
            placeholder="e.g. Node.js, React, Python"
            className="w-full border border-gray-300 rounded-xl p-3 text-sm bg-white text-gray-900 outline-none focus:border-[#0f6abf] focus:ring-1 focus:ring-[#0f6abf]/20 transition-colors"
            value={jobForm.skills_required || ""}
            onChange={(e) =>
              setJobForm({ ...jobForm, skills_required: e.target.value })
            }
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Qualifications</label>
          <input
            type="text"
            placeholder="e.g. B.Tech / M.Sc / PhD"
            className="w-full border border-gray-300 rounded-xl p-3 text-sm bg-white text-gray-900 outline-none focus:border-[#0f6abf] focus:ring-1 focus:ring-[#0f6abf]/20 transition-colors"
            value={jobForm.qualifications || ""}
            onChange={(e) =>
              setJobForm({ ...jobForm, qualifications: e.target.value })
            }
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Contact Email</label>
          <input
            type="email"
            placeholder="hr@company.com"
            className="w-full border border-gray-300 rounded-xl p-3 text-sm bg-white text-gray-900 outline-none focus:border-[#0f6abf] focus:ring-1 focus:ring-[#0f6abf]/20 transition-colors"
            value={jobForm.contact_email}
            onChange={(e) =>
              setJobForm({ ...jobForm, contact_email: e.target.value })
            }
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Application URL</label>
          <input
            type="text"
            placeholder="https://company.com/careers"
            className="w-full border border-gray-300 rounded-xl p-3 text-sm bg-white text-gray-900 outline-none focus:border-[#0f6abf] focus:ring-1 focus:ring-[#0f6abf]/20 transition-colors"
            value={jobForm.application_url || ""}
            onChange={(e) =>
              setJobForm({ ...jobForm, application_url: e.target.value })
            }
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Description</label>
          <textarea
            placeholder="Describe the position, responsibilities, requirements..."
            className="w-full border border-gray-300 rounded-xl p-3 text-sm bg-white text-gray-900 outline-none focus:border-[#0f6abf] focus:ring-1 focus:ring-[#0f6abf]/20 min-h-[100px] resize-y transition-colors"
            value={jobForm.description}
            onChange={(e) =>
              setJobForm({ ...jobForm, description: e.target.value })
            }
          ></textarea>
        </div>

        <button
          className="submit-btn mt-2 py-3 px-4 rounded-xl border-none bg-[#0f6abf] text-white text-sm font-medium cursor-pointer hover:bg-[#0a5ca8] transition-colors disabled:opacity-50"
          onClick={handleJobSubmit}
          disabled={loading}
        >
          {loading ? "Publishing..." : "Publish Job"}
        </button>
      </div>
    )}
  </section>

  {/* Live Opportunities Section */}
  <section className="
    w-full
    rounded-2xl border border-gray-200
    bg-white
    p-6
    shadow-sm
    transition-all duration-200
    hover:shadow-md
    hover:border-gray-300
  ">
    <div className="flex items-center gap-2 mb-6">
      <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
      <h4 className="text-lg font-semibold text-gray-900">Live Opportunities</h4>
    </div>
    
    {loading ? (
      <div className="text-center py-8">
        <div className="w-8 h-8 border-2 border-[#0f6abf] border-t-transparent rounded-full animate-spin mx-auto mb-3"></div>
        <p className="text-sm text-gray-500">Loading...</p>
      </div>
    ) : posts.length > 0 ? (
      posts.map((p, i) => (
        <div
          key={i}
          className="bg-gray-50 border border-gray-200 rounded-xl p-4 mb-4 cursor-pointer hover:border-[#0f6abf] transition-colors"
          onClick={() =>
           {
            window.history.pushState({}, "",`/post/${p.id}?type=${p.post_type}`);
            setModalType(`/post/${p.id}?type=${p.post_type}`);
            setActivePost(p);
            localStorage.setItem('activePost', JSON.stringify(p));
            setOpen(true);
           }
          }
        >
          <div className="opp-header flex items-center justify-between mb-3">
             <div className="flex gap-4">
               <div className="bg-[#e8f0f7] border border-[#0f6abf] text-[#0f6abf] text-xs font-semibold inline-block rounded-lg py-1 px-3">
              {p.post_type === "job" ? "Job" : "Post"}
            </div>
             <div className="flex items-center gap-1 text-gray-600">
  <img className="w-5 h-5" src={ReadIcon} alt="Read Icon" />
  <span className="text-sm font-medium">{Math.floor(Math.random() * 3)}</span>
</div>

             </div>
            <div className="text-xs text-gray-500">
              {new Date(p.created_at).toLocaleDateString()}
            </div>
            

          </div>

          <div className="opp-title text-base font-semibold text-gray-900 mb-2">
            {p.title}
          </div>

         <div>
  <div
    className={`opp-body text-gray-600 text-sm leading-rel mb-3 break-words ${
      expanded ? "" : "max-h-24 overflow-hidden"
    }`}
    dangerouslySetInnerHTML={{ __html: p.content }}
  ></div>

  {p.content && p.content.length > 200 && (
    <button
      className="text-blue-600 text-sm"
       onClick={(e) => {
    e.stopPropagation();
    setExpanded(!expanded);
  }}
    >
      {expanded ? "Read Less" : "Read More"}
    </button>
  )}
</div>
          {p.post_type === "job" && (
            <div className="job-details space-y-2 text-sm text-gray-700">
              {p.company_name && (
                <div><strong>Company:</strong> {p.company_name}</div>
              )}
              {p.location && (
                <div><strong>Location:</strong> {p.location}</div>
              )}
              {p.experience_level && (
                <div><strong>Experience:</strong> {p.experience_level}</div>
              )}
              {p.job_type && (
                <div><strong>Type:</strong> {p.job_type.replace("_", " ")}</div>
              )}
              {(p.salary_min || p.salary_max) && (
                <div>
                  <strong>Salary:</strong> {p.salary_min} - {p.salary_max} {p.currency}
                </div>
              )}
              {p.skills_required && (
                <div><strong>Skills:</strong> {p.skills_required}</div>
              )}
              {p.qualifications && (
                <div><strong>Qualifications:</strong> {p.qualifications}</div>
              )}
              {p.application_email && (
                <div><strong>Email:</strong> {p.application_email}</div>
              )}
            </div>
          )}
        </div>
      ))
    ) : (
      <div className="text-center py-8">
        <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
          </svg>
        </div>
        <h4 className="font-medium text-gray-700 mb-1">No opportunities yet</h4>
        <p className="text-sm text-gray-500">Be the first to share a post or job opportunity</p>
      </div>
    )}
  </section>
  
</aside>
 {open && modalType && (
  <PublicModalView
    key={modalType}   // forces remount when post changes
    open={open}
    activePost={activePost}
    setOpen={setOpen}
    type={modalType}
  />
)}

</>
    );
}
